import React from 'react';
import { TipsMapType, TipsMapFunType } from '../index';

export const filterTopicTipsText = {
  en: (
    <>
      <strong>Topic</strong>：Divide comments into topics through the rules or
      algorithms.
    </>
  ),
  zh: (
    <>
      <strong>话题</strong>
      ：通过游戏设定的规则或算法将评论划分至某个话题。
    </>
  ),
};

export const filterMonitorWayTipText: TipsMapType = {
  en: (
    <div>
      Monitor Method: Social media sourced opinion data is mainly collected and monitored through the following two methods:
      <br />
      - Web Crawler Collection: The opinion content is obtained by crawlers through pre-configured monitoring keywords and monitoring official accounts.
      <br />
      1. Keyword Monitoring: Contents(Posts only) obtained by searching keywords on social media.
      <br />
      2. Account Monitoring: Contents(Posts&Replies) obtained by monitoring official accounts on social media.
      <br />
      - External Data Sources <br />
      Some data is sourced from third-party platforms such as LevelUp, which provide supplemental social media opinion content.<br />
    </div>
  ),
  zh: (
    <div>
      监控方式：社媒来源的舆情数据主要通过以下两种方式进行采集与监控：
      <br />
      - 爬虫系统采集：基于预先配置的关键词与官方账号信息，由爬虫自动抓取相关舆情内容。
      <br />
      1. 监控关键词：在社交媒体平台上，通过设置关键词进行搜索，获取包含该关键词的主贴评论内容。
      <br />
      2. 监控官号：针对指定的官方账号，实时抓取其发布的所有主贴及回复评论内容，实现全方位覆盖。
      <br />
      - 外部数据源接入 <br />
      部分数据来源于第三方合作平台，如 LevelUp 等，提供的社媒舆情内容。 <br />
    </div>
  ),
};

export const timeFilterTipText: TipsMapType = {
  en: 'The chart ignores the date range you select in the date picker When Align by Launch Time is enabled. You can re-select in the top time filter.',
  zh: '打开对照相同上线天数开关后，原先的日期筛选将被重置，请重新选择顶部时间筛选器。',
};

export const keywordConfigNlpTips: TipsMapType = {
  en: 'Search for keywords from the NLP-generated keyword library',
  zh: '从NLP生成的词库中搜索关键词',
};

export const keywordConfigTips: TipsMapType = {
  en: 'Search for keywords from the user-configured keyword table',
  zh: '从用户预配置的码表中搜索关键词',
};

export const disableKeywordTips: TipsMapType = {
  en: 'To improve search efficiency, select up to 10 keywords',
  zh: '为提升搜索效率，最多选10个关键词',
};

export const regionFilterTips: TipsMapType = {
  en: `(Not recommended) Only applicable to mobile game store reviews and all game social media official account reviews that can identify the region. Other reviews are labeled as "global"`,
  zh: `（不推荐）仅适用于可识别地区的手游商店评论和全部游戏社媒官号评论。其他评论均标为"全球"`,
};

export const languageFilterTips: TipsMapType = {
  en: `(Recommended) NLP algorithms will process reviews from all sources to identify and label their language.`,
  zh: `（推荐）NLP算法将对所有来源的评论进行处理，以识别和标记其语种`,
};

export const influencerRegionFilterTips: TipsMapType = {
  en: `Region filter only supports filtering country information (if any) of Youtube Influencer, which is obtained from Influencer's "About". Other channels are "unidentified".`,
  zh: `Region筛选器仅支持筛选Youtube渠道网红的国家信息(如有)，通过Influencer的Youtube简介获取。其他渠道为"未定义国家/地区"。`,
};

export const influencerLanguageFilterTips: TipsMapType = {
  en: `The Language filter supports filtering Influencers from all sources, and NLP algorithms provide language labels through language recognition.`,
  zh: `Language筛选器支持筛选所有来源的Influencer，NLP算法通过语种识别提供语言标签。`,
};

export const reviewerFilterTips: TipsMapType = {
  en: 'Display all reviewers including those in the list below',
  zh: '显示所有发帖人，而非仅下方列表的发帖人',
};

export const steamIdFilterTips: TipsMapType = {
  en: 'Display all Steam ID including those in the list below',
  zh: '显示所有Steam ID，而非仅下方列表的Steam ID',
};

export const UTCDateFilterTips: TipsMapFunType = (str: string) => {
  return {
    en: `The current calculation time zone is UTC+${str} time zone.`,
    zh: `当前计算时区为UTC+${str}时区。`,
  };
};


export const UTCVideDateFilterTips: TipsMapFunType = (str: string) => {
  return {
    en: <>
      The current calculation time zone is UTC+{str} time zone.<br />
      The following videos are listed by release date.
    </>,
    zh: <>
      当前计算时区为UTC+{str}时区。<br />
      下方视频列表基于发布时间统计。
    </>,
  };
};


export const commonUrlDateFilterTips: TipsMapFunType = (str: string) => {
  return {
    en: (
      <>
        The current calculation time zone is UTC+{str} time zone. <br />
        For comprehensive comment analysis, we recommend selecting &quot;Last 90
        days&quot;. To analyze a specific period, you may customize the date range.{' '}
        <br />
        Note: The system will display &quot;No data&quot; if no comments exist within the
        selected range.
      </>
    ),
    zh: (
      <>
        当前计算时区为UTC+{str}时区。
        <br />
        分析全部评论推荐选择&quot;近90天&quot;;
        如需分析特定时间内新增的评论，可自定义时段。
        <br />
        注意：自定义时段如未覆盖评论，将提示无数据。
      </>
    ),
  };
};

export const influencerActivityDateFilterTips: TipsMapType = {
  en: (
    <>
      Refers to the time when Influencers post about selected games (UTC+8)
      <br />
      The page calculates the data of the last 90 days by default. Please wait
      for the calculation and loading if you want to change the time range.
    </>
  ),
  zh: (
    <>
      网红发布所选游戏帖子的时间（UTC+8）
      <br />
      页面默认计算近90天的数据，若要进行时间区间的修改，请耐心等待计算和加载。
    </>
  ),
};

export const gameAffinityFilterTips: TipsMapType = {
  en: (
    <>
      Percentage of content related to the game compared to the total content
      created by the creators. (In the selected time range)
    </>
  ),
  zh: (
    <>
      选定的单游戏相关的内容占网红创造的内容总数的百分比（在所选的时间区间内）
    </>
  ),
};

export const totalPublicationsFilterTips: TipsMapType = {
  en: (
    <>
      The number of the influencer's total publications in the selected time
      range.
    </>
  ),
  zh: <>网红在所选的时间区间内总发帖量</>,
};

export const avgViewsFilterTips: TipsMapType = {
  en: (
    <>
      The average number of views of the influencer's total posts in the
      selected time range.
    </>
  ),
  zh: <>网红在所选的时间区间内所有帖子的平均观看量</>,
};

export const avgEngagementRateFilterTips: TipsMapType = {
  en: (
    <>
      The average engagement rate (Engagement / View) of the influencer's total
      posts in the selected time range.
    </>
  ),
  zh: <>网红在所选时间区间内所有帖子的平均互动率（互动量/观看量）</>,
};

export const brandRelatedPublicationsFilterTips: TipsMapType = {
  en: (
    <>
      The number of the influencer's brand-related posts in the selected time
      range.
    </>
  ),
  zh: <>网红在所选的时间区间内本品牌游戏相关的发帖量</>,
};

export const brandRelatedAvgViewsFilterTips: TipsMapType = {
  en: (
    <>
      The average number of views of the influencer's brand-related posts in the
      selected time range.
    </>
  ),
  zh: <>网红在所选的时间区间内本品牌游戏帖子的平均观看量</>,
};

export const topicIncludeContainFilterTips: TipsMapType = {
  zh: (
    <>
      筛选包含所选话题的评论（此评论也可能提到其他话题）
      <br />
      例：选择话题a，提到a, a&b, 或者a&b&c话题的评论都会被统计
    </>
  ),
  en: (
    <>
      Select reviews that mention the chosen topics (These reviews may also
      reference other topics).
      <br />
      e.g. Select topic a, reviews that mention topics a, a&b, or a&b&c will be
      included.
    </>
  ),
};

export const topicIncludeOnlyContainFilterTips: TipsMapType = {
  zh: (
    <>
      筛选仅包含所选话题的评论（评论仅包含所选话题）
      <br />
      例：选择话题a，仅提到a话题的评论会被统计
    </>
  ),
  en: (
    <>
      Select reviews that mention only the chosen topics (These reviews
      exclusively reference the selected topics).
      <br />
      e.g. Select topic a, reviews that only mention topic a will be included.
    </>
  ),
};

export const topicExcludeContainFilterTips: TipsMapType = {
  zh: (
    <>
      排除包含所选话题的评论（此评论也可能提到其他话题）
      <br />
      例：选择话题a，提到a, a&b, 或者a&b&c话题的评论都会被排除
    </>
  ),
  en: (
    <>
      Exclude reviews that mention the chosen topics (These reviews may also
      reference other topics).
      <br />
      e.g. Select topic a, reviews that mention topics a, a&b, or a&b&c will be
      excluded.
    </>
  ),
};

export const topicExcludeOnlyContainFilterTips: TipsMapType = {
  zh: (
    <>
      排除仅包含所选话题的评论（此评论仅包含所选话题）
      <br />
      例：选择话题a，仅提到a话题的评论会被排除
    </>
  ),
  en: (
    <>
      Exclude reviews that mention only the chosen topics (These reviews
      exclusively reference the selected topics).
      <br />
      e.g. Select topic a, reviews that only mention topic a will be excluded.
    </>
  ),
};

export const SteamAllReviewsFilterTips: TipsMapType = {
  zh: (
    <>
      游戏在Steam页面展示的全部评论数值。Steam平台仅统计带了星标的Steam评论，评论有星标说明评论者通过购买、被赠送或临时免费许可证获得的游戏。
    </>
  ),
  en: (
    <>
      The All Review data shown on the game's Steam page. Steam only count the
      reviews that are marked with a star. A starred review indicates that the
      reviewer activated the game via a Steam key, received it as a gift, or
      obtained it via a temporary free license.
    </>
  ),
};

export const SteamAllReviewsPositiveFilterTips: TipsMapType = {
  zh: <>在全部评论中，正面评价所占的比例。</>,
  en: <>The proportion of positive reviews among All Reviews.</>,
};

export const SteamRecentReviewsFilterTips: TipsMapType = {
  zh: (
    <>游戏在Steam页面展示的近期评论数值。取值时间段通常是过去30天内的评论。</>
  ),
  en: (
    <>
      The Recent Reviews data shown on the game's Steam page. The review period
      is usually the last 30 days.
    </>
  ),
};

export const SteamRecentReviewsPositiveFilterTips: TipsMapType = {
  zh: <>在近期评论中，正面评价所占的比例。</>,
  en: <>The proportion of positive reviews among Recent Reviews.</>,
};

export const SteamAddedPositiveFilterTips: TipsMapType = {
  zh: <>在新增评论中，正面评价所占的比例。</>,
  en: <>The proportion of positive reviews among all Added Reviews.</>,
};

export const ChangeFilterShowTips: TipsMapType = {
  zh: <>更改筛选条件后，需要点击Confirm刷新页面</>,
  en: (
    <>
      After changing the filter criteria, you need to click confirm to refresh
      the page.
    </>
  ),
};

export const channelExceedLimitTips: TipsMapType = {
  zh: <>新闻包含选项超出最大数量限制（2000），请调整后重试。</>,
  en: <>News options exceed the maximum limit (2000). Please adjust and retry.</>,
};
